<template>
	<v-navigation-drawer
      :value="value"
      temporary
      fixed
      right
      width='500'
      app
      @input="em"
      style='height: 100%'
    >
		<div class="bill" v-if="order">
			<div
				class="flex pa-5 flex-vcenter"
			>
				<h3 class='ma-0' style='margin: 0'>
					Carrello
				</h3>
				<span class="flex-grow-1" />
				<v-icon @click="em(false)" large color="var(--quomi-primary)">fas fa-times-circle</v-icon>
			</div>
      		<delivery-widget class="ml-5" :noCity="true"/>
			<v-divider />
			<!-- <v-alert color="var(--quomi-primary)" class="text-white ma-5 text-body-small" style='font-weight:bold' v-if="order.countItems() > 0 && order.getDiffToFreeShipping() < 0">
				Consegna standard gratuita con <span class="text-bold">{{ -order.getDiffToFreeShipping() | priceFilter }}</span> in più
			</v-alert> -->
			<div v-if="order.countItems() === 0" class="text-center pa-5 mt-10">
				<div>
					<img src='https://api.quomi.it/oldimg/empty-cart.png' style='margin-left: -25px'>
				</div>
				<div class="pa-5 text-body-mid">
					Il tuo carrello è vuoto
				</div>
				<CTA
					class="full ma-auto "
					size="big"
					:content="`Inizia la spesa`"
					@click="close()"
				/>
				<div class="mt-10 tag-partner">
					<router-link :to="{name: 'profile_orders'}" class="rebuy-btn pa-3 mt-5 text-bold">				
						<i class="fas fa-sync-alt"></i> 
						<span class="text-body-mid pl-3">Riordina l'ultima spesa</span>
					</router-link>
				</div>
			</div>
			<div
				class="pa-5 text-body-small pt-0"
				v-if="order.countItems() > 0"
			>
				<!--<p v-if="order && order.is_to_deliver">
					Ordina entro {{ order.date.cutoff | readableDate }} per riceverla il {{ order.date.delivery | readableDate }}
				</p>-->
				<div class="flex" v-if="order.prices.plan > 0">
					<div>Kit Ricette</div>
					<div class="flex-right">{{ order.prices.plan | priceFilter }}</div>
				</div>

				<div
					class="flex"
					v-if="order.prices.recipes > 0"
				>
					<div>Premium</div>
					<div class="flex-right">{{ order.prices.recipes | priceFilter }}</div>
				</div>
				
				<div
					class="flex"
					v-if="order.extras.length > 0"
				>
					<div>Bottega</div>
					<div class="flex-right">{{ order.prices.extras | priceFilter }}</div>
				</div>


				<div class="flex">
					<div>
						{{ $t("components.checkout.bill.total_delivery") }}
					</div>

					<div class="flex-right" v-if="order.prices.delivery > 0">
						{{ order.prices.delivery | priceFilter }}
					</div>

					<div class="flex-right" v-else>
						<div class="delivery-free-bill">GRATUITA</div>
					</div>
				</div>

				<div class="flex" v-if="order.prices.discount > 0">
					<div class="text-bold" style="color: var(--quomi-red-hover)">{{ $t("components.checkout.bill.total_discount") }}</div>
					
					<div class="flex-right text-bold" style="color: var(--quomi-red-hover)">– {{ order.prices.discount | priceFilter }}</div>
				</div>

				<div class="flex text-bold">
						<div>Totale</div>
						<div class="flex-right">{{ order.prices.net | priceFilter }}</div>
				</div>

				<div class="" v-if="orderHasEdenred">
					<br>
					<div class="flex">
						<div class="flex-right">di cui {{ order.transactions.edenred | priceFilter }} pagati in Buoni Pasto</div>
					</div>
				</div>
				<hr>
				
	          	<h4>
	          		Hai un codice sconto o una gift card?
	          	</h4>
				<div >
	                <add-coupon
	                    ref="couponSection"
	                    :order='order'
	                    :showLabel="false"
	                >
	                </add-coupon>
				</div>
				<v-divider />

				<div>
					<div
						class="section"
						v-if="menu && !errorStore.message"
					>

						<div class="flex" v-if="order.prices.plan > 0">
							<div>
								<h4
									v-html="`Kit ricette`"
								/>
							</div>
							<div class="flex-right text-body-small">
								<span v-if="order.recipes.length >= 1">
									(<b>{{ order.getPlanPricePerPortion() | priceFilter }}</b> a porzione)
								</span>
								&nbsp;
								<info-tooltip
									style='font-size: 13px;'
									:src="`Aumenta le quantità e ottieni il <b>miglior prezzo a porzione!</b>`"
								/>
							</div>
						</div>
						<div v-for="(recipe, index) in order.recipes" :key="`${index}`" class="bill-item">
							<div @click="toRecipe(recipe.id)" class="d-flex align-items-center">
								<div class="recipe-image">
									<img :src="recipe.images.small ? recipe.images.small : recipe.images.big">
								</div>
								<div class="recipe-name text-body-small">
									<div class="recipe-name-content" v-html="recipe.name" />
									<!--<div class="info-small-normal">({{ people * recipe.quantity }} porzioni)</div>-->
								</div>	
							</div>



								<div class="flex-fill"></div>

								<div>
									<div
										class="flex flex-vcenter" style='max-height: 24px'
									>
										<CTA
											class="full"
											:disabled="updating"
											@click="$_orderAction_removeRecipe(recipe)"
											size="small"
											:content="`<i class='fas fa-minus' aria-hidden='true'></i>`"
										/>

										<div class="quantity-extra">
											{{ people * recipe.quantity }} porzioni
										</div>

										<CTA
											class="full"
											:disabled="updating || !$_orderAction_isOneMoreRecipeAvailable(recipe)"
											@click="$_orderAction_addRecipe(recipe)"
											size="small"
											:content="`<i class='fas fa-plus' aria-hidden='true'></i>`"
										/>
									</div>
								</div>
						</div>

					</div>

					<div class="section" v-if="order.extras.length > 0">
						<h4 v-if="order.prices.plan > 0">Bottega:</h4>
						<div v-if="order.extras.length <= 0">Aggiungi i tuoi preferiti </div>

						<div v-for="(extra, index) in order.extras" v-if="extra.quantity > 0" :key="index">
							<div class="flex flex-vcenter bill-item">
								<div @click="toProduct(extra.id)" class="d-flex align-items-center">
									<div class="inline recipe-image" v-if="extra.images">
										<img :src="extra.images.small ? extra.images.small : extra.images.big">
									</div>
									<div>
										<div class="text-body-mid recipe-name-content">{{ extra.title }}</div>

									<div class="info-small-normal ">
										<div class="d-flex align-items-center pt-1">
											<section v-if="extra.price && extra.discount.value > 0">
												<small class="text-body-mid text-decoration-line-through">€ {{ extra.discount.original}}</small>
												<small class="text-body-mid px-3 text-muted">|</small>
											</section>
												<small class="text-body-mid" :class="[extra.discount && extra.discount.value > 0 ? 'text-danger' : '']">€ {{ extra.price }}</small>
										</div>
									</div>
									<!--<div class="info-small-normal">Quantità: {{ extra.quantity }}</div>-->
								</div>
								</div>


					

								<div class="flex-fill"></div>

								<div>
									<div
										class="flex flex-vcenter" style='max-height: 24px'
									>
										<CTA
											class="full"
											:disabled="updating"
											@click="$_extraAction_remove(extra)"
											size="small"
											:content="`<i class='fas fa-minus' aria-hidden='true'></i>`"
										/>

										<div class="quantity-extra pa-5">
											{{ $_extraAction_quantityExtraInOrder(extra.id) }}
										</div>

										<CTA
											class="full"
											:disabled="updating || $_extraAction_outOfStock(extra) || maxAvailable == extra.quantity+1"
											@click="$_extraAction_add(extra)"
											size="small"
											:content="`<i class='fas fa-plus' aria-hidden='true'></i>`"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

		          <v-alert style='background:tomato;color:white' v-if="errorStore.message">
		            {{ errorStore.message }}
		          </v-alert>
		          	

				</div>
			</div>
			<br><br><br><br><br><br>


			<div class="bill-container-confirm" elevation="5" v-if="order.countItems() > 0">
				<div class="flex px-3 flex-vcenter pa-5 py-3 text-white text-body-small" style="font-weight:bold;background: var(--quomi-orange)" v-if="!!priceMinAlert()" v-html="priceMinAlert()"></div>

				<div class="flex px-3 flex-vcenter">

					<div>
						Totale carrello<br> 

						<span class="text-bold">{{ order.prices.net | priceFilter }}</span>
					</div>

					<div class="flex-fill" />
					<CTA
						v-if="getNextSectionPage"
						@click="goNextSectionPage()"
						class="btn-big"
						:loading="updating"
						:disabled="!!priceMinAlert() || !canConfirm || updating"
						:content="`Prosegui`"
					/>

					<CTA
						v-else
						@click="!priceMinAlert() && confirm()"
						class="btn-big"
						:loading="updating"
						:disabled="!!priceMinAlert() || !canConfirm || updating"
						:content="this.ctaLabel"
					/>
				</div>
			</div>
		</div>
	</v-navigation-drawer>
</template>

<script>
const moment = require('moment')

import SocialShare from '../SocialShare/SocialShare'
import { shipmentDayChanging } from '../../mixins/shipmentDayChanging'
import { prices } from '../../mixins/prices'
import { extraAction } from '../../mixins/extraAction'
import { orderAction } from '../../mixins/orderAction'
import { orderStore } from '../../store/orderStore'

import { wishlist } from '../../mixins/wishlist'
import { sections } from '../../mixins/sections'
import InfoTooltip from '../Parts/InfoTooltip'
import AddCoupon from './AddCoupon'
import DeliveryWidget from './DeliveryWidget'

export default {
	props: ['value'],
	mixins: [
		shipmentDayChanging,
		extraAction,
		orderAction,
		prices,
    sections
	],
	components: {
    DeliveryWidget,
		SocialShare,
		AddCoupon,
		InfoTooltip
	},
	filters: {
		readableDate (val) {
			return moment(val).locale('it').format('dddd D MMMM')
		}
	},

	watch: {
		'active' () {
			this.$emit('update:billIsActive', this.active)
		},
	},

	computed: {


		ctaLabel () {
			return this.$t('components.checkout.next');
		},


		people () {
			if (!this.order || !this.order.id) return this.$root.user && this.$root.user.subscription ? this.$root.user.subscription.plan.people : 2
			return this.order.plan.people
		},

		loading () {
			return !this.order || !this.maxRecipes
		},

		isDesktop () {
			return this.$mq.isDesktop()
		},

		meals () {
			return Object.values(this.recipes).map(a => a.quantity).reduce((a, b) => a + b, 0)
		},

		user () {
			return this.$root.$data.user
		},

		order () {
			return orderStore.state.order
		},

		recipes () {
			return this.order.recipes
		},

		extras () {
			return this.order.extras
		},
	},

	methods: {

		priceMinAlert () {

			this.allowMinCheck = true;

			if (!window.orderRawPlan) {
				//return 'Aggiungi o rimuovi alcune ricette per procedere'
			}

			if (this.allowMinCheck && this.order && !this.order.prices.min_reached) {

				if(this.order && this.order.discount && this.order.discount.group && this.order.discount.group.length > 0 && this.order.discount.group[0].coupon > 0) {

					return 'Raggiungi '+this.order.prices.min_gross+'€ di spesa per attivare il tuo codice!'

				}

				return 'Raggiungi '+this.order.prices.min_gross+'€ di spesa per andare alla cassa!'
			}

			return null;
		},

		close() {
			this.value = false
			if (this.$route.name != "shop-by-tag") {
				this.$router.push({name: "flow-subscribed"});
			}
		},
		em(val) {
			this.$emit('input', val)
		},

		confirm () {
			if (this.updating || !this.canConfirm) {
				return;
			}

			this.$_orderAction_updateCurrentRecipes(0).then(() => {
				if(this.user && this.user.subscription.status === 'pending') {
					this.$router.push({ name: this.$route.name == 'subscription-step' ? 'verify-page' : 'subscription-step' })
					this.em(false)
				} else {
					this.$router.push({ name: 'verify-page' })
					this.em(false)
				}
			}).catch((error) => {
				this.em(false)
			});
		},
		toProduct(id) {
			this.$router.push({name: 'product', params: {id: id}})
		},
		toRecipe(id) {
			this.$router.push({name: 'recipe', params: {id: id}})
		},

		goNextSectionPage() {
			this.$_orderAction_updateCurrentRecipes(0).then(() => {
        // Go to next section, if there is no next go to verify-page
        

				this.$router.push({ path: this.getNextSectionPage.firstUrl })
			}).catch((error) => {
				console.log(error);
			});
		},
	}
}

</script>

<style scoped>
.rebuy-btn {
	width: fit-content;
	display: inline;
	border: 2px solid var(--quomi-primary);
	border-radius: 20px;
	color: var(--quomi-primary);;
}
.bill-container-confirm {
	position: absolute;
    right: 0;
    bottom: 0;
    background: white;
    width: 100%;
    box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.52) !important;
}

.bill.section + .section {
	padding-top: 20px;
}

h3 {
	font-weight: bold;
	margin-bottom: 20px;
	text-align: left;
}

.bill-panel_inner {
	background-color: #fbf1d7;
	padding: 25px;
	position: -webkit-sticky;
	position: sticky;
	top: 165px;
	border-radius: 6px;
	min-height: 250px;
	min-width: 300px;
}

.alert + .content-layout .bill {
	margin-top: 50px;
}

.bill .section + .section {
	padding-top: 30px;
}

.bill-item {
	margin: 10px 0;
	display: flex;
    align-items: center;
    line-height: 1.2;
}

.bill-item .recipe-name {
	display: -webkit-box;
    -webkit-box-orient: vertical;
    position: relative;
	line-height: 1.1;
}

.recipe-name-content {
	display: -webkit-box;
    -webkit-box-orient: vertical;
    position: relative;
	line-height: 1.1;
	overflow: hidden;
	-webkit-line-clamp: 2;
	overflow: hidden;
}


.bill-item.placeholder {
	color: #9ea0a1;
	background-color: #fbf1d7;
	background-color: #fffefba3;
	padding: 7px 0;
}

.bill-section {
	padding: 20px;
}

.bill-section + .bill-section {
	margin-top: 20px;
}
.recipe-image {
	min-width: 50px;
	min-height: 33px;
	max-width: 50px;
	max-height: 33px;
	overflow: hidden;
	vertical-align: middle;
	margin-right: 10px;
	border-radius: 4px;
}

.recipe-image.placeholder {
	text-align: center;
}

.recipe-image.placeholder img {
	width: 75%;
}

.share-group  {
	margin: 0px;
	border-radius: 6px;
	height: auto;
}

.icons-panel {
	justify-content: flex-start;
}

.title-section {

}

.title-section h4 {
	font-size: 18px;
}


.delivery-free-bill {
	text-transform: uppercase;
	font-weight: bold;
	color: var(--quomi-primary);
}

.quantity-extra {
	width: 80px;
	text-align: center;
}

@media (max-width: 320px ) {
.quantity-extra {
	width: 60px;
}

.flex-fill {
	margin-left: 10px;
}
}
</style>
